<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <form #dataServiceForm="ngForm">
    <div class="fluid-container">
      <div class="form-group mt-3">
        <label>Source*</label>
        <input class="form-control" type="text" name="source" [(ngModel)]="rowData.SOURCE" required>
        @if (dataServiceForm.form?.get('source')?.invalid && dataServiceForm.form?.get('source')?.touched) {
<span class="form-error-container">
          Source is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Active</label>
        <input class="form-control" type="text" name="active" [(ngModel)]="rowData.IS_ACTIVE">
      </div>
    </div>
  </form>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="saving" (click)="save()">
    @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
